/* ARRAY - The K-Beauty Edit, mobile companion. v2, 14 Sep 2026.

   The phone shows ONE product at a time standing on the podium scene. This file
   builds the three things the section markup does not have and drives them:
     - the "01 / 04" counter in the header
     - the ADD TO BAG button
     - the previous / current / next tab strip (one tab per product)
   All three are display:none outside the 749px query, so the desktop scene is
   untouched; the old arrow / dot / thumbnail controls are gone with the rail.

   THE BUTTON AND THE TABS ARE APPENDED TO .kb, NOT INSIDE .kb-item. Each item
   is an <a> to the product page, and a <button> inside an <a> is invalid markup
   that phones handle inconsistently.

   VARIANT IDS ARE NOT IN THE MARKUP, so the button resolves one by fetching
   <product-url>.js the first time a slide is opened, then caches it on the
   element. That keeps the 20KB section file untouched; the cost is one small
   JSON request per product, only for products the visitor actually looks at.
   A product whose variants are all sold out gets a disabled SOLD OUT button.

   The section renders `p.price` (the product's minimum) in .kb-price, so the
   button deliberately does NOT rewrite the price - it adds the first AVAILABLE
   variant, and for a multi-variant product those two can disagree. If that ever
   matters, send people to the product page instead of adding from here. */
(function () {
  if (window.__bdKbMobBound) return;
  window.__bdKbMobBound = true;

  var SEC = '.beyondads-kbeauty-section';
  var PHONE = '(max-width: 749px)';

  function phone() { return window.matchMedia && window.matchMedia(PHONE).matches; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function items(sec) { return sec.querySelectorAll('.kb-stage .kb-item'); }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function build(sec) {
    if (sec.__kbm) return;
    var list = items(sec);
    if (!list.length) return;
    var kb = sec.querySelector('.kb') || sec;
    var stage = sec.querySelector('.kb-stage');
    if (!stage) return;

    var mob = sec.querySelector('.kb-mob');
    var count = el('p', 'kbm-count', '<b data-kbm-now>01</b> / ' + pad(list.length));
    if (mob) mob.insertBefore(count, mob.firstChild);

    var add = el('button', 'kbm-add', 'ADD TO BAG');
    add.type = 'button';
    add.setAttribute('data-kbm-add', '');

    var tabs = el('div', 'kbm-tabs', '');
    tabs.setAttribute('role', 'group');
    tabs.setAttribute('aria-label', 'Choose a product');
    for (var i = 0; i < list.length; i++) {
      var nm = (list[i].querySelector('.kb-name') || {}).textContent || ('Product ' + (i + 1));
      var t = el('button', 'kbm-tab', '');
      t.type = 'button';
      t.setAttribute('data-kbm-go', String(i));
      t.setAttribute('aria-label', String(nm).trim());
      t.appendChild(el('span', 'kbm-tab-n', ''));
      t.appendChild(el('span', 'kbm-tab-i', ''));
      t.firstChild.textContent = String(nm).trim();
      t.lastChild.textContent = pad(i + 1);
      tabs.appendChild(t);
    }

    kb.appendChild(add);
    kb.appendChild(tabs);

    sec.__kbm = { count: count, add: add, tabs: tabs, i: -1 };
    go(sec, 0);
  }

  function label(sec, text, disabled) {
    var s = sec.__kbm;
    if (!s) return;
    s.add.textContent = text;
    s.add.disabled = !!disabled;
  }

  function resolve(sec, item) {
    var s = sec.__kbm;
    if (!s) return;
    if (item.__v === 0) { label(sec, 'SOLD OUT', true); return; }
    if (item.__v) { label(sec, 'ADD TO BAG', false); return; }

    var href = item.getAttribute('href') || '';
    if (!href || href === '#') { label(sec, 'ADD TO BAG', true); return; }

    var path;
    try { path = new URL(href, window.location.origin).pathname; }
    catch (e) { path = href.split('?')[0]; }
    if (!/\/products\//.test(path)) { label(sec, 'ADD TO BAG', true); return; }

    label(sec, 'ADD TO BAG', true);
    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = null, list = (p && p.variants) || [];
        for (var i = 0; i < list.length; i++) { if (list[i].available) { v = list[i]; break; } }
        item.__v = v ? v.id : 0;
        if (sec.__kbm && sec.__kbm.i >= 0 && items(sec)[sec.__kbm.i] === item) {
          if (v) label(sec, 'ADD TO BAG', false);
          else label(sec, 'SOLD OUT', true);
        }
      })
      .catch(function () { label(sec, 'ADD TO BAG', true); });
  }

  function go(sec, i) {
    var s = sec.__kbm;
    var list = items(sec);
    if (!s || !list.length) return;
    var n = list.length;
    i = ((i % n) + n) % n;
    if (s.i === i) return;
    s.i = i;

    for (var k = 0; k < n; k++) list[k].classList.toggle('is-on', k === i);

    var now = s.count.querySelector('[data-kbm-now]');
    if (now) now.textContent = pad(i + 1);

    for (var t = 0; t < s.tabs.children.length; t++) {
      var on = (t === i);
      s.tabs.children[t].classList.toggle('is-on', on);
      s.tabs.children[t].setAttribute('aria-current', on ? 'true' : 'false');
    }

    resolve(sec, list[i]);
  }

  function addToCart(sec) {
    var s = sec.__kbm;
    if (!s || s.add.__busy) return;
    var item = items(sec)[s.i];
    if (!item || !item.__v) return;

    s.add.__busy = true;
    var was = s.add.textContent;
    s.add.textContent = 'ADDING...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: item.__v, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        s.add.textContent = 'ADDED';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () { s.add.textContent = was; s.add.__busy = false; }, 1600);
      })
      .catch(function () { s.add.textContent = was; s.add.__busy = false; });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var sec = e.target.closest(SEC);
    if (!sec || !sec.__kbm) return;

    var tab = e.target.closest('[data-kbm-go]');
    if (tab) { e.preventDefault(); go(sec, parseInt(tab.getAttribute('data-kbm-go'), 10) || 0); return; }

    if (e.target.closest('[data-kbm-add]')) { e.preventDefault(); addToCart(sec); }
  });

  function initAll() {
    if (!phone()) return;
    var secs = document.querySelectorAll(SEC);
    for (var i = 0; i < secs.length; i++) build(secs[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('resize', initAll);
  setTimeout(initAll, 600);
  setTimeout(initAll, 1600);
})();
